const clickOutsideFunc = (elem, cb, event) => {
  if (!elem || !event || !cb) {
    return;
  }

  if (!elem.contains(event.target)) {
    cb(event);
  }
};

export const clickOutside = (elem, cb) => {
  document.addEventListener('click', clickOutsideFunc.bind(null, elem, cb), false);
  document.addEventListener('touchstart', clickOutsideFunc.bind(null, elem, cb), false);
  document.addEventListener('focusin', clickOutsideFunc.bind(null, elem, cb), false);
};

export const removeClickOutside = (elem, cb) => {
  document.removeEventListener('click', clickOutsideFunc.bind(null, elem, cb), false);
  document.removeEventListener('touchstart', clickOutsideFunc.bind(null, elem, cb), false);
  document.removeEventListener('focusin', clickOutsideFunc.bind(null, elem, cb), false);
};

/**
 * Returns TRUE if provided targetRef is a reference containing a valid 'current', provided event contains a valid 'target' and the event target is not contained in current.
 * @param {Object} targetRef - A component reference defined using useRef()
 * @param {Object} event - Event object
 * @returns {Boolean}
 */
export const canHandleOutside = (targetRef, event) =>
  Boolean(
    event &&
      event.target &&
      targetRef &&
      targetRef.current &&
      !targetRef.current.contains(event.target)
  );
